import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { ErrorCard } from 'components/ErrorCard/ErrorCard';
import { useIntroducerData } from 'contexts/IntroducerData/IntroducerData.context';
import { usePhoneNumber } from 'hooks/usePhoneNumber';
import { Helmet } from 'react-helmet';
import { BaseLayout } from '../components/Layout/BaseLayout/BaseLayout';

export const ForbiddenPage = () => {
  const { introducerType } = useIntroducerData();
  const isAccountant = introducerType === 'accountant';
  const { phoneNumberLink } = usePhoneNumber();

  return (
    <>
      <Helmet>
        <meta
          property="og:description"
          content="403 error. Sorry, you do not have permissions for this page."
        />
      </Helmet>
      <BaseLayout pageTitle={t`403 - Access denied | Introducer Portal`}>
        <ErrorCard
          code={403}
          message={
            <>
              <Trans>
                Sorry, but you don't have permission to view this page.
              </Trans>
              <Trans>
                If you think you should have access to this page, please{' '}
                <a
                  href={
                    isAccountant
                      ? 'mailto:accountants@iwoca.co.uk'
                      : `mailto:${t`brokers@iwoca.co.uk`}`
                  }
                  data-testid="email-link"
                >
                  email
                </a>{' '}
                or{' '}
                <a href={`tel:${phoneNumberLink}`} data-testid="call-link">
                  call
                </a>{' '}
                our introducer team to get this resolved.
              </Trans>
            </>
          }
        />
      </BaseLayout>
    </>
  );
};
